module.exports = __webpack_public_path__ + "img/69.433fff05.jpg";